import graphql__c263b58828da63002121 from "./__generated__/DeleteInvoiceDialog_invoice.graphql.ts";
import graphql__5c2f8f4f745ee80ed197 from "./__generated__/DeleteInvoiceDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type DeleteInvoiceDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const DeleteInvoiceDialog: React.FC<DeleteInvoiceDialogProps> = (props) => {

    const navigate = useNavigate();
    const intl = useIntl();
    const invoice = useFragment(
        graphql__c263b58828da63002121,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__5c2f8f4f745ee80ed197,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                    navigate('/invoices')
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteInvoice'})
            }
        )
    }

    const initialValues = {
        id: invoice.id
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.DeleteInvoiceDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.DeleteInvoiceDialog.submitLabel'})}
                    dangerous={true}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.DeleteInvoiceDialog.confirmMessage'}, {customer: invoice.customerAccount.customerName})}
                    </p>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default DeleteInvoiceDialog;
